module.exports = __webpack_public_path__ + "img/whatsapp.79522c37.png";